import { render, staticRenderFns } from "./VariantSifterAssociationRegionPlot.vue?vue&type=template&id=194b436e&scoped=true&"
import script from "./VariantSifterAssociationRegionPlot.vue?vue&type=script&lang=js&"
export * from "./VariantSifterAssociationRegionPlot.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterAssociationRegionPlot.vue?vue&type=style&index=0&id=194b436e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194b436e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('194b436e')) {
      api.createRecord('194b436e', component.options)
    } else {
      api.reload('194b436e', component.options)
    }
    module.hot.accept("./VariantSifterAssociationRegionPlot.vue?vue&type=template&id=194b436e&scoped=true&", function () {
      api.rerender('194b436e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterAssociationRegionPlot.vue"
export default component.exports